import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import userInfoApi, { userInfoSync } from 'hub-http/userInfo';
import { RequestState } from '../filter/requests/request-state';
import { IFRAME_WIDGET_ACCESS } from 'dashboard-lib/public/scope/scope-name';
// import { gate as gateV3Parser } from 'hub-http/gates';

export const userInfoNamespace = 'userInfo';
export const CUSTOM_REPORTING_ACCESS = 'custom-reporting-access';
const initialState = {
  loading: true,
  error: null,
  fetchStatus: RequestState.UNINITIALIZED,
  data: {
    gates: [],
    portal: {},
    user: {}
  }
};
export const userInfoPromise = () => {
  return new Promise((resolve, reject) => {
    try {
      const userInfoSyncValue = userInfoSync();
      resolve({
        loading: false,
        error: null,
        data: userInfoSyncValue
      });
    } catch (e) {
      userInfoApi().then(response => {
        resolve({
          loading: false,
          error: null,
          data: response
        });
      }).catch(error => {
        reject(error);
      });
    }
  });
};
export const fetchUserInfo = createAsyncThunk('user/fetch', async () => {
  const response = await userInfoPromise();
  // @ts-expect-error Object is of type 'unknown'
  return response.data;
});
const userInfoSlice = createSlice({
  name: userInfoNamespace,
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: builder => {
    builder.addCase(fetchUserInfo.pending, state => {
      state.fetchStatus = RequestState.PENDING;
      state.error = null;
      state.loading = true;
    });
    builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
      const {
        gates,
        user,
        portal
      } = action.payload;
      state.data.gates = gates;
      state.data.user = user;
      state.data.portal = portal;
      state.loading = false;
      state.error = null;
      state.fetchStatus = RequestState.SUCCEEDED;
    });
    builder.addCase(fetchUserInfo.rejected, (state, action) => {
      const error = action.payload;
      state.error = error;
      state.fetchStatus = RequestState.FAILED;
      state.loading = false;
    });
  }
});
export const selectFetchUserInfoStatus = ({
  userInfo
}) => {
  return userInfo.fetchStatus;
};
export const selectUser = ({
  userInfo
}) => {
  return userInfo.data.user;
};
export const selectUserId = state => {
  const user = selectUser(state);
  return user.user_id;
};
export const selectUserScope = state => {
  const user = selectUser(state);
  return user.scopes;
};
export const selectIfUserHasScopes = targetScopes => state => {
  const scopes = selectUserScope(state);
  if (!scopes) return false; // TODO: remove this when finish migration
  return scopes.every(scope => targetScopes.includes(scope));
};
export const selectIfUserHasCustomReportAccess = state => {
  return selectIfUserHasScopes([CUSTOM_REPORTING_ACCESS])(state);
};
export const selectAllGates = ({
  userInfo
}) => {
  return userInfo.data.gates;
};
export const createUserGateSelector = (...gates) => createSelector(selectAllGates, gatesList => gates.every(targetGate => gatesList.includes(targetGate)));
export const selectUserHasScopes = (...scopes) => createSelector(selectUserScope, scopesList => scopes.every(scope => scopesList.includes(scope)));

// Scopes
export const selectHasIframeWidgetAccess = selectUserHasScopes(IFRAME_WIDGET_ACCESS);
export default userInfoSlice.reducer;